/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../lib/@waca/core-client/js/core-client/ui/core/View'
], function(View) {

	var FlyoutContentBase = View.extend({

		init: function( options ) {
			this.popupParent = options.popupContainer;
			this.content = options.content || '';
			FlyoutContentBase.inherited('init', this, arguments);
		},

		/**
		 * Returns html content for the view
		 * Derived classes would override this
		 */
		getRenderedHtml: function() {
			return this.content; // return html output
		},

		/**
		 * Callback invoked on Popup getting shown, this is where event handlers could be hooked up in the view
		 * Optional, Derived classes could override this
		 */
		onPopupShown: function() {
			//placeholder for now
		},

		/**
		 * Callback invoked on Popup getting closed
		 * Optional, Derived classes could override this
		 */
		onPopupClosed: function() {
			//placeholder for now
		}
	});
	return FlyoutContentBase;
});
